import { render, staticRenderFns } from "./HP.vue?vue&type=template&id=68ba60d5&"
import script from "./HP.vue?vue&type=script&lang=js&"
export * from "./HP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports